import { Navigate, Route, Routes } from "react-router-dom";
import { RequireAuth, RequireCapability } from "@/auth/guard";
import { AppShell } from "@/components/app-shell";
import { AlertsPage } from "@/pages/alerts";
import { IdentitiesPage } from "@/pages/identities";
import { LoginPage } from "@/pages/login";
import { OverviewPage } from "@/pages/overview";
import { RunsPage } from "@/pages/runs";
import { UsersPage } from "@/pages/users";

/**
 * Split out from the entry point so a test can mount the same route table
 * under a MemoryRouter: the guards are part of what is being tested, and a
 * test that renders a page component directly proves nothing about them.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route
          index
          element={
            <RequireCapability capability="ops:read">
              <OverviewPage />
            </RequireCapability>
          }
        />
        <Route
          path="identities"
          element={
            <RequireCapability capability="ops:read">
              <IdentitiesPage />
            </RequireCapability>
          }
        />
        <Route
          path="runs"
          element={
            <RequireCapability capability="ops:read">
              <RunsPage />
            </RequireCapability>
          }
        />
        <Route
          path="users"
          element={
            <RequireCapability capability="users:manage">
              <UsersPage />
            </RequireCapability>
          }
        />
        <Route
          path="alerts"
          element={
            <RequireCapability capability="alerts:read">
              <AlertsPage />
            </RequireCapability>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
